import axios from "axios"

import { isJsonString } from "../utils"

const isProduction = process.env.NODE_ENV === 'production'

const BASE_URL = process.env.REACT_APP_BASE_CLINNET + process.env.REACT_APP_BASE_PATH

const handleError = error => {
  
  const errorMessage = error && error?.message !== undefined ? error?.message : error
  const response     = errorMessage ? JSON.parse(errorMessage) : errorMessage

  ///const newError = { message: response.message.message , code: -1}
  return Promise.reject( response )
}

const API = axios.create({
  baseURL: BASE_URL,
  headers: {'Content-Type': 'application/json', 'accept': 'application/json', 'X-Client': process.env.REACT_APP_CLIENT },
  responseType: 'json',
  transformResponse: [ 
    response => {
    
      let json 
      
      json = isJsonString(response) ? JSON.parse(response) : response
      
      if (json.status === undefined || json.status === 1) {
        return json
      } 
      // if (json?.mensagem === 'Nenhum paciente encontrado.') {
      //   return json
      // } 
      else {  
        throw response  
      }
    },
  ],
  // validateStatus: function (s, a) {
  //     console.log(s, a, '500')
  //     //return status < 500; // Resolve only if the status code is less than 500
  // }
})

API.isProduction = isProduction

// Add a request interceptor
API.interceptors.request.use(function (config) {
  return config   
}, handleError)

  
// Add a response interceptor
API.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
 
  return response?.data?.dados
}, handleError)

export default API


